import React from 'react'
import { FormattedMessage } from 'react-intl'

const NotQuiteReady = () => (
  <div className="not-quite-ready-container">
    <div className="icon-not-ready" />
    <p className="not-quite-ready">
      <FormattedMessage
        id={'InternalReview.IsntReady'}
        defaultMessage={"This quest isn't ready for internal review yet."}
      />
    </p>
    <p className="guidance">
      <FormattedMessage
        id={'InternalReview.CompleteAllTheRequiredFields'}
        defaultMessage={
          'Complete all the required fields, then assign this quest to a reviewer in your organization for review.'
        }
      />
    </p>
  </div>
)

export default NotQuiteReady



// WEBPACK FOOTER //
// ./src/components/quest/review/internalreview/NotQuiteReady.js